/**
 * localStorage keys — the ONE place every persisted-key literal lives.
 *
 * WHY HERE (not the app layer): the app used to declare `BOARD_STORAGE_KEY` in
 * `src/app/board/default-board.ts`, but Spaces introduces a SECOND key and the two
 * must never drift or collide. Keys are a cross-cutting contract (the app reads/writes
 * them; e2e fixtures assert them), so they belong in the schema package — the single
 * source of truth both the SPA client and tests import (index.ts barrel).
 *
 * `default-board.ts` now RE-EXPORTS `BOARD_STORAGE_KEY` from the barrel so its four
 * existing import sites (use-board, use-editable-board, OnboardingBar, itself) keep
 * working unchanged. The e2e fixtures keep their own literal copy on purpose — they
 * run outside the src module graph (Playwright, no path aliases) and asserting the
 * literal there is a deliberate belt-and-suspenders check that the key never changes.
 *
 * VERSION SUFFIX: the `_v1` suffix is the STORAGE-SLOT version, independent of the
 * schemaVersion inside the blob. Bumping it means "start a fresh slot, abandon the
 * old one" — a last resort. Normal schema evolution rides the migrate-then-validate
 * ladder INSIDE the value (migrate.ts / spaces-migrate.ts), never a key rename.
 */

/**
 * Single-board slot (legacy + still the board every user has today). Unchanged
 * literal value — every existing production user's board lives under this exact key.
 * loadSpaces' legacy migration reads THIS slot's raw string to lift a lone board
 * into a Spaces envelope.
 */
export const BOARD_STORAGE_KEY = 'briefpane_board_v1' as const;

/**
 * Multiple-named-boards ("Spaces") slot. New in the Spaces feature. The app writes
 * the SpacesSchema envelope here; on first run after the upgrade it is ABSENT, which
 * is the signal to attempt the legacy migration from BOARD_STORAGE_KEY.
 */
export const SPACES_STORAGE_KEY = 'briefpane_spaces_v1' as const;
